const $ = window.jQuery;

import View from "./view";
import gsap from "gsap";
import "../modules/plugin.lazyload";
import Flickity from "flickity";
import Layout from "../modules/layout";
import feather from "feather-icons";

export default class MainView extends View {
    constructor($el, store) {
        super($el);

        this.store = store;
        this.isFirstVisit = true;

        $(document).scroll(() => this.scrollHandler());

        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }

        this.fitViewportHeight();
        this.interaction();
        this.initRendered();

        $(window).resize(() => this.fit());
    }

    isHome() {
        return this.$el.hasClass("home");
    }

    isSingular() {
        return this.$el.hasClass("is-singular");
    }

    scrollHandler() {
        this.store.scrollLeft =
            window.pageXOffset !== undefined
                ? window.pageXOffset
                : (
                      document.documentElement ||
                      document.body.parentNode ||
                      document.body
                  ).scrollLeft;
        this.store.scrollTop =
            window.pageYOffset !== undefined
                ? window.pageYOffset
                : (
                      document.documentElement ||
                      document.body.parentNode ||
                      document.body
                  ).scrollTop;

        this.store.updateFragment(
            window.location.href,
            "scrollTop",
            this.store.scrollTop,
        );
        this.adjustMainHeader();
    }

    adjustMainHeader() {
        let availableHeight = $(document).height() - $(window).height();
        let scrollPercent = this.store.scrollTop / availableHeight;
        let headerHeight = $(".main-header").outerHeight();
        let $headerWrap = $(".main-header-wrap");
        let $footer = $(".footer");
        if ($(".footer").length) {
            let footerRect = $(".footer")[0].getBoundingClientRect();
            $headerWrap.toggleClass("is-bg-black", footerRect.top < 0);
        }

        let top = Math.min(headerHeight, this.store.scrollTop * 0.5) * -1;

        $headerWrap.css({
            top: top,
        });
    }

    interaction() {
        $(document).on("click", "a[href^=\\#]", (e) => {
            e.preventDefault();
            e.stopPropagation();
            let href = $(e.target).closest("a").attr("href");
            if (href === "#") {
                return;
            }
            let $el = $(href);
            if ($el.length) {
                this.scrollTo($el.offset().top - 30, {
                    duration: 500,
                });
            }
        });

        $(document).keydown((e) => {
            if (e.keyCode === 27) {
                this.hideLightbox();
            }
        });
    }

    render(data, opts) {
        let options = $.extend(
            {},
            {
                replace: "everyting",
            },
            opts,
        );

        let $pageContent = $(".page-content");

        gsap.to($pageContent, 0.2, {
            opacity: 0,
            onComplete: () => {
                switch (options.replace) {
                    case "everyting":
                        $pageContent.html(data.pageContent);
                        break;
                }
                this.scrollTo(data.scrollTop);
                this.$el.attr("class", data.bodyClass);
                this.$el.attr("data-filter-id", data.filterId);
                document.querySelector("title").innerHTML = data.titleTag;

                this.initRendered();

                gsap.to($pageContent, 0.2, {
                    opacity: 1,
                });
            },
        });
    }

    scrollTo(pos, options) {
        let settings = $.extend(
            {},
            {
                duration: 0,
            },
            options,
        );

        $("html,body").animate(
            {
                scrollTop: pos,
            },
            settings.duration,
        );
    }

    initRendered() {
        $("html").removeClass("is-loading");
        $("body").trigger("mainView:render");

        new Layout(
            $(".is-singular .page-content"),
            $(".single-content .layout-item"),
        );
        this.fit();

        this.initHomeGallery();
        this.adjustNavMenu();

        this.isFirstVisit = false;

        this.initLightbox();
        feather.replace();
        this.initYouTube();
        this.initLazyload();
        this.fit();
    }

    initLightbox() {
        if (this.isHome() || !this.isSingular()) {
            return;
        }

        let $elements = $(".image-item:not(:has(.is-embed))");

        if (!$elements.length) {
            return;
        }
        let $lightbox = $('<div class="lightbox" />');

        $elements.each((i, el) => {
            let $el = $(el);
            $el.attr("data-lightbox-index", i);
            let $cell = $(
                '<figure class="lightbox_cell fit-images-with-js" />',
            );
            $cell.append($el.find(".is-image").clone());

            let $caption = $("<figcaption />");
            $caption.text($el.find("figcaption").text());
            $caption.prepend(
                `<span class='cell-index'>${i + 1}/${$elements.length}</span>`,
            );

            $cell.append($caption);
            $lightbox.append($cell);
        });

        $(".page-content").prepend($lightbox);

        let f = new Flickity($lightbox[0], {
            setGallerySize: false,
            pageDots: false,
            wrapAround: true,
        });
        $lightbox.data("flickity", f);

        let $lightboxClose = $('<button class="lightbox_close">close</button>');
        $lightboxClose.click(() => {
            this.hideLightbox();
        });
        $lightbox.prepend($lightboxClose);

        f.on("select", () => {
            if (f.velocity < 0) {
                $lightbox
                    .addClass("moved-to-right")
                    .removeClass("moved-to-left");
            } else {
                $lightbox
                    .addClass("moved-to-left")
                    .removeClass("moved-to-right");
            }
            setTimeout(() => {
                $lightbox.removeClass("moved-to-right moved-to-left");
            }, 1);
        });

        $(".image-item img").click((e) => {
            let index = $(e.currentTarget)
                .parents(".image-item")
                .data("lightbox-index");
            this.showLightbox(index);
        });
    }

    hideLightbox() {
        $("body").removeClass("show-lightbox");
    }

    showLightbox(id = 0) {
        $("body").addClass("show-lightbox");
        let $lightbox = $(".lightbox");
        if (!$lightbox.length) {
            return;
        }
        $lightbox.focus();
        let f = $lightbox.data("flickity");
        f.select(id, true, true);
    }

    fit() {
        if (!this.isMobile()) {
            this.fitViewportHeight();
        }
        this.fitImages();
        this.fitItems();
        this.fitSingleColumns();
        $(".lazyload").lazyload("maybeReload");
        $(".main-body").css({
            marginTop: $(".main-header-wrap").outerHeight(),
        });
    }

    fitViewportHeight() {
        let vh = $(window).height();
        document.documentElement.style.setProperty("--vh", vh + "px");
    }

    /**
     * Detects if the window dimensions are almost the screens dimensions
     * and the device doesn't support hovering
     */
    isMobile() {
        let widthDiff = window.screen.width - window.innerWidth;
        let heightDiff = window.screen.height - window.innerHeight;
        return !this.supportsHover() && heightDiff < 150 && widthDiff < 150;
    }

    /**
     * Detects hover support
     */
    supportsHover() {
        return window.matchMedia(
            "screen and (hover: hover), screen and (min--moz-device-pixel-ratio: 0), screen and (-ms-high-contrast:none)",
        ).matches;
    }

    fitImages() {
        $(".fit-images-with-js").each((i, el) => {
            let $wrap = $(el);
            let wrapRatio = $wrap.width() / $wrap.height();
            $wrap.find("img").each((i, el) => {
                let $img = $(el);
                let imgRatio = $img.data("ratio");
                if (imgRatio > wrapRatio) {
                    $img.addClass("is-wider");
                } else {
                    $img.removeClass("is-wider");
                }
            });
        });
    }

    initLazyload() {
        $(".lazyload").lazyload({
            debug: false, // globals.booleans.isDev,
            lazy: true,
            onLoad: ($el, instance, response) => {
                $el.parents(".scaled-media,.image").addClass("lazyloaded");
            },
        });
    }

    fitItems() {
        var $wrap = $(".entry-list");
        var wrapWidth = $wrap.width();
        var maxWidth = 450;

        if (this.$el.hasClass("has-child-terms")) {
            maxWidth = 800;
        }

        var amount = Math.ceil(wrapWidth / maxWidth);
        var width = wrapWidth / amount;
        var percent = (width / wrapWidth) * 100;

        $(".entry-list_item").each(function () {
            let $item = $(this);
            $item.css({
                width: percent + "%",
            });
        });
    }

    fitSingleColumns() {
        let $columns = $(".single-columns");

        if (!$columns.length) {
            return;
        }

        let $items = $(".column-item");
        let $column1 = $(".column-2");
        let $column2 = $(".column-1");

        if ($items.length === 2) {
            $column1 = $(".column-1");
            $column2 = $(".column-2");
        }

        let $currentColumn = $column1;

        var isColumnLayout = $columns.find(".column-item").length !== 0;

        if ($(window).width() > 1000 && $items.length > 1) {
            if (isColumnLayout) {
                return;
            }

            $items.each(function (index) {
                var $item = $(this);
                if (index % 2 === 0) {
                    $currentColumn = $column2;
                } else {
                    $currentColumn = $column1;
                }

                if ($currentColumn.children().length % 2 === 1) {
                    $item.addClass("alternate");
                }

                $currentColumn.append($item);
            });

            var $highestColumn =
                $column1.outerHeight() > $column2.height()
                    ? $column1
                    : $column2;
            var $lowestColumn =
                $column1.outerHeight() < $column2.height()
                    ? $column1
                    : $column2;

            // moves all items from the higher column to the lower one, until it isn't lower anymore
            $highestColumn.find(".column-item").each(function () {
                if ($(this).position().top > $lowestColumn.height()) {
                    $(this).appendTo($lowestColumn);
                }
            });

            $lowestColumn =
                $column1.outerHeight() < $column2.height()
                    ? $column1
                    : $column2;
            // $(".single-credits").appendTo($lowestColumn);
        } else {
            if (!isColumnLayout) {
                return;
            }

            $items.prependTo($columns);
            $items.removeClass("alternate");
            $items = $columns.find(".column-item");

            $items
                .sort(function (a, b) {
                    var an = parseInt($(a).data("order"), 10);
                    var bn = parseInt($(b).data("order"), 10);
                    return an > bn ? 1 : -1;
                })
                .appendTo(".items-container");
        }
        this.initYouTube();
    }

    adjustNavMenu() {
        $(".main-nav li").each((i, el) => {
            let $li = $(el);
            let $a = $li.find("a");
            let href = $a.attr("href");
            if (window.location.href.indexOf(href) !== -1) {
                $li.addClass("current-menu-item");
            } else {
                $li.removeClass("current-menu-item");
            }
        });
    }

    initHomeGallery() {
        $(".home_gallery").each((index, el) => {
            let $el = $(el);
            let $cells = $el.find(".home_gallery_cell");
            let f = new Flickity($el[0], {
                setGallerySize: false,
                pageDots: false,
                wrapAround: true,
                autoPlay: globals.booleans.isDev ? false : 8000,
                pauseAutoPlayOnHover: false,
                initialIndex: Math.floor(Math.random() * $cells.length),
            });
            $el.data("flickity", f);
        });
    }

    initYouTube() {
        if (this.youtubePlayerReady) {
            this.onYouTubeIframeAPIReady();
            return;
        }
        this.youtubePlayerReady = false;

        // https://developers.google.com/youtube/iframe_api_reference?hl=de
        var tag = document.createElement("script");
        tag.src = "//www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        var self = this;
        window.onYouTubeIframeAPIReady = () => this.onYouTubeIframeAPIReady();
    }

    onYouTubeIframeAPIReady() {
        this.youtubePlayerReady = true;
        this.hideVideoPostersOnPlay();
        $(".video_poster").click((e) => {
            let $embed = $(e.currentTarget).parents(".video").find("iframe");
            let ytPlayer = $embed.data("ytPlayer");
            if (ytPlayer) {
                ytPlayer.playVideo();
            }
        });
    }

    hideVideoPostersOnPlay() {
        $(".video:has(.is-youtube)").each((i, el) => {
            let $el = $(el);
            let $iframe = $el.find("iframe");
            let $parent = $iframe.parent();
            let lastPlayer = $iframe.data("ytPlayer");
            if (lastPlayer) {
                lastPlayer.destroy();
            }
            $iframe.appendTo($parent);
            let player = new YT.Player($iframe[0], {
                events: {
                    onStateChange: (event) => {
                        this.onYTPlayerStateChange(event, $el);
                    },
                },
            });
            $iframe.data("ytPlayer", player);
            $el.removeClass("is-started");
        });
    }

    onYTPlayerStateChange(event, $el) {
        if (event.data === window.YT.PlayerState.BUFFERING) {
            $el.addClass("is-started");
        } else if (event.data === window.YT.PlayerState.ENDED) {
            setTimeout(() => event.target.stopVideo(), 500);
            $el.removeClass("is-started");
        }
    }
}
